module.exports = __webpack_public_path__ + "media/images/icons/academy-humanities-bf32c9b475527016bbf17b7bccb1fb0d.svg";